export default __webpack_public_path__ + "7581eeae5864c5f0d2f2a618768dace3.svg";